import { render } from "./CloseIcon.vue?vue&type=template&id=543ea020"
const script = {}

import exportComponent from "/codebuild/output/src973090976/src/remoterespects-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__